import React, { useEffect } from 'react';
import Box from '@material-ui/core/Box';
import {
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
} from '@material-ui/core';
import { Clear, PhoneCallback, Search } from '@material-ui/icons';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import InfiniteScroll from 'react-infinite-scroll-component';
import Badge from '@material-ui/core/Badge';
import TablePagination from 'components/atoms/TablePagination/TablePagination';
import { UserListDto } from 'api/user';
import Spin from 'components/atoms/Spin/Spin';
import { CustomSelect } from 'components/atoms/CustomSelect/CustomSelect';
import CustomDatePicker from 'components/atoms/CustomDatePicker/CustomDatePicker';
import { CourierDto } from 'api/couriers';
import OrderTableItem from 'components/molecules/OrderTableItem/OrderTableItem';
import OrderCommentDialog from 'components/organisms/OrderCommentDialog/OrderCommentDialog';
import OrderCourierDialog from 'components/organisms/OrderCourierDialog/OrderCourierDialog';
import OrderDataListDialog from 'components/organisms/OrderDataListDialog/OrderDataListDialog';
import OrderDetailsDialog from 'components/organisms/OrderDetailsDialog/OrderDetailsDialog';
import { CourierCallEditDialog } from '../../components/organisms/CourierCallEditDialog';
import { useOrderLogic } from './useOrderLogic';
import { useStyles } from './styles';
import { useSelector } from 'react-redux';
import { getUserInfo } from 'store/slices/userInfoSlice';
import { NOT_GEOCODED } from './types';

/*import { useSelector } from 'react-redux';
import { getUserInfo } from '../../store/slices/userInfoSlice';*/


const Orders = () => {
    const classes = useStyles();

    //const { roles } = useSelector(getUserInfo);

    const {
        loading,
        actionLoading,
        items,
        productId,
        productCode,
        products,
        handleProductChange,
        emcTypeId,
        emcTypes,
        handleEmcTypeChange,
        isReserved,
        regionId,
        handleRegionChange,
        regions,
        courier,
        activeCouriers,
        startDate,
        handleStartDateChange,
        untilDate,
        handleUntilDateChange,
        menuStatusId,
        statuses,
        statusId,
        handleStatusChange,
        search,
        handleSearchChange,
        handleSearchKeyDown,
        handleSearch,
        handleReset,
        selected,
        actions,
        handleActionClick,
        singleSelect,
        handleSelectAllClick,
        isSelected,
        handleClick,
        total,
        perPage,
        page,
        setPage,
        setPerPage,
        activeAction,
        commentOpen,
        handleCommentClose,
        courierDialogOpen,
        handleActionCourierSelect,
        handleActionCourierClose,
        selectedItems,
        selectedOpen,
        handleSelectedClose,
        handleSelectedOpen,
        handleOrderDetailOpen,
        handleOrderDetailClose,
        orderDetailOpen,
        orderId,
        handleDeleteAll,
        getAllWithBarcode,
        barCodeLoading,
        courierSelectLoading,
        tabValue,
        handleTabChange,
        courierList,
        loadCouriers,
        courierHasMore,
        courierCount,
        getAll,
        setSelected,
        setSelectedItems,
        courierCallOpen,
        handleCourierCallClose,
        isCourierCall,
        handleCourierCallClick,
        isReceived,
        branches,
        branchId,
        branchCode,
        handleBranchChange,
        hasPermissionToEdit,
        totalSum,
        setTotalSum,
        isGeocoding,
        isGeozoning,
        geocodingStatuses,
        geocodingStatusId,
        handleGeocodingStatusChange,
        setIsOrderChanged,
        geozoneName,
        geozones,
        handleGeozoneChange,
        DROPDOWN_SELECT_ALL,
        NOT_GEOZONE
    } = useOrderLogic();

    useEffect(() => {
        const fixedClass = classes.actionButtonsFixed;
        const actionButtons = document.getElementById('action-buttons');
        if (!actionButtons) {
            return;
        }

        const buttonsOffset = actionButtons.offsetTop || 0;

        const onScroll = (event: any) => {
            const scrolled = event.target.scrollTop;

            if (scrolled > buttonsOffset) {
                const arr = actionButtons.className.split(' ');
                if (arr.indexOf(fixedClass) === -1) {
                    actionButtons.className += ` ${fixedClass}`;
                }
            } else if (scrolled < buttonsOffset) {
                actionButtons.className = actionButtons.className.replace(
                    new RegExp(` ${fixedClass}`, 'g'),
                    ''
                );
            }
        };

        const main = document.getElementById('layout-container');
        main?.addEventListener('scroll', onScroll);

        return () => {
            main?.removeEventListener('scroll', onScroll);
        };
    }, [classes.actionButtonsFixed]);

    const { branch } = useSelector(getUserInfo);
    const relogEnabled = branch?.relog_enabled;

    // @ts-ignore
    return (
        <Box position={'relative'}>
            {!isReserved && (
                <>
                    <Grid container spacing={3}>
                        <Grid item xs={6} md={4} xl={4} lg={4}>
                            <CustomSelect
                                cls={classes.formControl}
                                label="Выберите продукт"
                                labelId="product-id"
                                value={productId}
                                items={products}
                                onChange={handleProductChange}
                            />
                        </Grid>
                        <Grid item xs={6} md={4} xl={4} lg={4}>
                            <CustomSelect
                                cls={classes.formControl}
                                label="Выберите тип EMS"
                                labelId="emc-type"
                                value={emcTypeId}
                                items={emcTypes}
                                onChange={handleEmcTypeChange}
                            />
                        </Grid>
                        <Grid item xs={6} md={4} xl={4} lg={4}>
                            <FormControl
                                className={classes.formControl}
                                variant="outlined"
                                error={isReserved && !regionId}
                            >
                                <InputLabel id="product-id-label">Регион</InputLabel>
                                <Select
                                    labelId="product-id-label"
                                    id="product-id"
                                    value={regionId}
                                    label="Регион"
                                    onChange={handleRegionChange}
                                >
                                    {regions.length > 1 && (
                                        <MenuItem value="">
                                            <em>Не выбрано</em>
                                        </MenuItem>
                                    )}

                                    {regions.map((region, index) => (
                                        <MenuItem key={index} value={region.id}>
                                            {region.description}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {isReserved && !regionId && (
                                    <FormHelperText>Выберите регион</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className={classes.filterRow} wrap="wrap">
                        <Grid item xs={6} md={4} xl={4} lg={4}>
                            <FormControl
                                className={classes.formControl}
                                disabled={branches?.length === 1}
                                variant="outlined"
                            >
                                <InputLabel id="branch-id-label">Отделение</InputLabel>
                                <Select
                                    labelId="branch-id-label"
                                    id="branch-id"
                                    value={branchId}
                                    label="Отделение"
                                    onChange={handleBranchChange}
                                >
                                    {branches?.length && (
                                        <MenuItem value="">
                                            <em>Не выбрано</em>
                                        </MenuItem>
                                    )}

                                    {branches?.map((branch, index) => (
                                        <MenuItem key={index} value={branch.id}>
                                            {branch.description}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} md={4} xl={4} lg={4}>
                            <CustomDatePicker
                                label="Дата создания с:"
                                value={startDate}
                                onChange={handleStartDateChange}
                            />
                        </Grid>
                        <Grid item xs={6} md={4} xl={4} lg={4}>
                            <CustomDatePicker
                                label="Дата создания по:"
                                value={untilDate}
                                onChange={handleUntilDateChange}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={3} className={classes.filterRow}>
                        {!menuStatusId && (
                            <Grid item xs={12} md={4} xl={4} lg={4}>
                                <CustomSelect
                                    cls={classes.formControl}
                                    label="Статус"
                                    labelId="status"
                                    value={statusId}
                                    items={statuses}
                                    onChange={handleStatusChange}
                                />
                            </Grid>
                        )}
                        <Grid item xs={12} md={4} xl={4} lg={4}>
                            <TextField
                                label="Введите номер заявки или ФИО клиента"
                                fullWidth
                                value={search}
                                variant="outlined"
                                className={classes.formControl}
                                onChange={handleSearchChange}
                                onKeyDown={handleSearchKeyDown}
                                autoFocus
                            />
                        </Grid>
                        <Grid item xs={12} md={4} xl={4} lg={4}>
                            <Autocomplete
                                id="courier"
                                options={activeCouriers}
                                disabled={regionId === ''}
                                getOptionLabel={(option: UserListDto | CourierDto) =>
                                    `${option.last_name} ${option.first_name} (${option.phone_number})`
                                }
                                // @ts-ignore
                                onChange={(
                                    // @ts-ignore
                                    event: any,
                                    newValue: UserListDto | CourierDto | null
                                ) => {
                                    courier.current = newValue;
                                }}
                                value={courier.current}
                                renderInput={(params) => (
                                    <TextField {...params} label="Курьер" variant="outlined" />
                                )}
                            />
                        </Grid>
                        {isGeocoding && <Grid item xs={12} md={4} xl={4} lg={4}>
                            <CustomSelect
                                includeNoneOption={false}
                                cls={classes.formControl}
                                label="Выберите статус геокодирования"
                                labelId="geocode-status-id"
                                value={geocodingStatusId}
                                items={geocodingStatuses}
                                onChange={handleGeocodingStatusChange}
                            />
                        </Grid>}
                        {isGeozoning && <Grid item xs={12} md={4} xl={4} lg={4}>
                            <CustomSelect
                                includeNoneOption={false}
                                cls={classes.formControl}
                                label="Выберите зону"
                                labelId="geozone-id"
                                value={geozoneName}
                                items={geozones}
                                onChange={handleGeozoneChange}
                            />
                        </Grid>}
                    </Grid>
                </>
            )}

            {isReserved && (
                <>
                    <Grid container spacing={3}>
                        <Grid item xs={6} md={4} xl={4} lg={4}>
                            <CustomSelect
                                cls={classes.formControl}
                                label="Выберите продукт"
                                labelId="product-id"
                                value={productId}
                                items={products}
                                onChange={handleProductChange}
                            />
                        </Grid>
                        <Grid item xs={6} md={4} xl={4} lg={4}>
                            <FormControl
                                className={classes.formControl}
                                variant="outlined"
                                error={isReserved && !regionId}
                            >
                                <InputLabel id="product-id-label">Регион</InputLabel>
                                <Select
                                    labelId="product-id-label"
                                    id="product-id"
                                    value={regionId}
                                    label="Регион"
                                    onChange={handleRegionChange}
                                >
                                    {regions.length > 1 && (
                                        <MenuItem value="">
                                            <em>Не выбрано</em>
                                        </MenuItem>
                                    )}

                                    {regions.map((region, index) => (
                                        <MenuItem key={index} value={region.id}>
                                            {region.description}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {isReserved && !regionId && (
                                    <FormHelperText>Выберите регион</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} md={4} xl={4} lg={4}>
                            <TextField
                                label="Введите данные курьера"
                                fullWidth
                                value={search}
                                variant="outlined"
                                className={classes.formControl}
                                onChange={handleSearchChange}
                                onKeyDown={handleSearchKeyDown}
                                autoFocus
                            />
                        </Grid>
                    </Grid>
                </>
            )}

            <Grid container justify="space-between" className={classes.buttons}>
                <Grid item>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.btn}
                        onClick={handleSearch}
                        startIcon={<Search />}
                    >
                        Поиск
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.btn}
                        onClick={handleReset}
                        startIcon={<Clear />}
                    >
                        Сброс
                    </Button>
                    {isCourierCall && isReceived && /* (roles?.length > 0 && roles?.filter((r) => r === 'ADMIN').length > 0) &&*/ (
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.btn}
                            onClick={handleCourierCallClick}
                            startIcon={<PhoneCallback />}
                        >
                            Вызов курьера
                        </Button>
                    )}
                </Grid>
                <Grid item style={{ marginLeft: 'auto' }}>
                    <Box
                        display="flex"
                        justifyContent="end"
                        position="relative"
                        id="action-buttons"
                        minWidth={40}
                        minHeight={60}
                    >
                        {actionLoading && <Spin />}
                        {!actionLoading && menuStatusId && (
                            <Button
                                variant="contained"
                                color="secondary"
                                className={classes.orderButton}
                                onClick={handleSelectedOpen}
                            >
                                {selected.length > 0 ? 'Выбрано:' : 'Сканировать'}{' '}
                                {selected.length > 0 && (
                                    <span className={classes.orderCount}>{selected.length}</span>
                                )}
                            </Button>
                        )}
                        {!actionLoading &&
                            actions.map((item, index) => {
                                let isDisabled = selected.length === 0;
                                if (relogEnabled) {
                                    isDisabled = selected.length === 0
                                        // || (item.code === 'BIND_TO_ZONE' && geocodingStatusId !== 'GEOCODED')
                                        || (item.code === 'ASSIGN_COURIER' && [DROPDOWN_SELECT_ALL, NOT_GEOZONE, NOT_GEOCODED].includes(geozoneName));
                                }
                                return (
                                    <Button
                                        key={index}
                                        disabled={isDisabled}
                                        variant="contained"
                                        color="primary"
                                        className={[classes.actionButton, classes.btn].join(' ')}
                                        onClick={() =>
                                            handleActionClick(item.code, item.is_comment_required)
                                        }
                                    >
                                        {item.description}
                                    </Button>
                                );
                            })}
                    </Box>
                </Grid>
            </Grid>
            <TablePagination
                total={total}
                perPage={perPage}
                page={page}
                onChangePage={setPage}
                onChangeRowsPerPage={setPerPage}
            />
            <Box position={'relative'} overflow="auto">
                <Box display="flex">
                    {isReserved && (
                        <Box flex={1}>
                            <Typography variant="button">
                                Курьеры: <strong>{courierCount}</strong>
                            </Typography>
                            <InfiniteScroll
                                dataLength={courierList.length}
                                next={loadCouriers}
                                hasMore={courierHasMore}
                                loader={'Loading...'}
                                height={400}
                                className={classes.infinityScroll}
                            >
                                <Tabs
                                    orientation="vertical"
                                    variant="scrollable"
                                    value={tabValue}
                                    onChange={handleTabChange}
                                    aria-label="Vertical tabs example"
                                    className={classes.tabs}
                                    style={{ width: '100%' }}
                                >
                                    {courierList.map((cou, index) => (
                                        <Tab
                                            key={index}
                                            label={
                                                <span>
                                                    <span
                                                        dangerouslySetInnerHTML={{
                                                            __html: `${cou.last_name} ${cou.first_name[0]
                                                                }.(${cou.phone_number}${cou.post_box_number
                                                                    ? `, <span style="background-color: #99c0ff;">${cou.post_box_number}</span>`
                                                                    : ''
                                                                }) -`,
                                                        }}
                                                    />
                                                    <Badge
                                                        badgeContent={
                                                            <strong>{cou.order_count}</strong>
                                                        }
                                                        max={99}
                                                        color="secondary"
                                                        classes={{ colorSecondary: classes.badge }}
                                                    />
                                                </span>
                                            }
                                            classes={{
                                                root: classes.tab,
                                                wrapper: classes.tabWrapper,
                                            }}
                                            onClick={() => {
                                                courier.current = cou;
                                                setSelected([]);
                                                setSelectedItems([]);
                                                setTotalSum(0);
                                                if (page === 0) {
                                                    getAll();
                                                } else {
                                                    setPage(0);
                                                }
                                            }}
                                        />
                                    ))}
                                </Tabs>
                            </InfiniteScroll>
                        </Box>
                    )}
                    <Box flex={4}>
                        <Box>
                            {!singleSelect && (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color="primary"
                                            indeterminate={
                                                selected.length > 0 &&
                                                selected.length < items.length
                                            }
                                            checked={
                                                items.length > 0 && selected.length === items.length
                                            }
                                            onChange={handleSelectAllClick}
                                            inputProps={{
                                                'aria-label': 'select all desserts',
                                            }}
                                        />
                                    }
                                    label="Выбрать все"
                                />
                            )}
                            {selected.length > 0 && productCode === 'KP' && (
                                <span
                                    style={{
                                        display: 'inlineFlex',
                                        alignItems: 'center',
                                        verticalAlign: 'middle',
                                        fontSize: '1rem',
                                        fontWeight: 'normal',
                                    }}
                                >{`Общая сумма: ${totalSum} тг.`}</span>
                            )}
                        </Box>
                        {loading && <Spin variant="inline" />}
                        {!loading && (
                            <>
                                {items.map((item, index) => {
                                    const isItemSelected = isSelected(item.id);
                                    const labelId = `enhanced-table-checkbox-${index}`;
                                    return (
                                        <OrderTableItem
                                            key={index}
                                            handleOpenDetails={handleOrderDetailOpen}
                                            handleClick={handleClick}
                                            isItemSelected={isItemSelected}
                                            item={item}
                                            singleSelect={singleSelect}
                                            labelId={labelId}
                                            isGeocoding={isGeocoding}
                                            isGeozoning={isGeozoning}
                                        />
                                    );
                                })}
                            </>
                        )}
                    </Box>
                </Box>
            </Box>

            <OrderCommentDialog
                activeAction={activeAction}
                open={commentOpen}
                selected={selected}
                onClose={handleCommentClose}
            />

            <OrderCourierDialog
                open={courierDialogOpen}
                onSelect={handleActionCourierSelect}
                onClose={handleActionCourierClose}
                loading={courierSelectLoading}
                parentRegionId={regionId}
                parentProduct={productCode}
                parentBranchCode={branchCode}
            />

            <OrderDataListDialog
                items={selectedItems}
                open={selectedOpen}
                onClose={handleSelectedClose}
                onDeleteAll={handleDeleteAll}
                onSelect={handleClick}
                onSearch={getAllWithBarcode}
                loading={barCodeLoading}
            />

            <OrderDetailsDialog
                id={orderId}
                onChange={setIsOrderChanged}
                open={orderDetailOpen}
                onClose={handleOrderDetailClose}
                hasPermissionToEdit={hasPermissionToEdit}
                isGeocoding={isGeocoding}
                isGeozoning={isGeozoning}
            />
            <CourierCallEditDialog open={courierCallOpen} onClose={handleCourierCallClose} />
        </Box>
    );
};

export default Orders;
